import { EyeIcon, EyeOffIcon } from "lucide-react";

import { useApp } from "@/hooks/use-app";

import { Button } from "../ui/button";
import { Skeleton } from "../ui/skeleton";
import {
  Tooltip,
  TooltipProvider,
  TooltipTrigger,
  TooltipContent,
} from "../ui/tooltip";
import { useBalanceQuery } from "./hooks/queries/use-balance-query";

export function WalletBalance() {
  return (
    <div className="balance text-sm font-light inline-flex items-center justify-between w-full">
      <BalanceValue />

      <HideBalanceValueButton />
    </div>
  );
}

function BalanceValue() {
  const { isLoading, data: balance } = useBalanceQuery();
  const { isBalanceValueHidden } = useApp();

  if (isLoading || !balance) {
    return (
      <span className="value">
        <Skeleton className="w-8" />
      </span>
    );
  }

  if (isBalanceValueHidden) {
    return (
      <span className="value">
        <span className="font-semibold">R$ ****</span>
      </span>
    );
  }

  return (
    <span className="value">
      <span className="font-semibold">
        {new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(balance.value)}
      </span>
    </span>
  );
}

function HideBalanceValueButton() {
  const { isBalanceValueHidden, toggleBalanceValue } = useApp();

  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipContent>
          {isBalanceValueHidden ? "Mostrar saldo" : "Ocultar saldo"}
        </TooltipContent>

        <TooltipTrigger>
          <Button
            variant="ghost"
            size="icon"
            className="w-8 h-8"
            onClick={toggleBalanceValue}
          >
            {isBalanceValueHidden ? (
              <EyeIcon className="w-3 h-3" />
            ) : (
              <EyeOffIcon className="w-3 h-3" />
            )}
          </Button>
        </TooltipTrigger>
      </Tooltip>
    </TooltipProvider>
  );
}
